import { isSSR } from 'lib/helpers/isSSR/isSSR'

/**
 * An abstraction over sessionStorage.getItem to handle SSR renders
 * @param {string} key session storage key
 * @returns {(string|null)}
 */
export const getSSItem = (key: string) => (isSSR() ? null : window.sessionStorage.getItem(key))
